module.exports = __webpack_public_path__ + "img/logo.fd388173.png";